import { useQuery } from "@tanstack/react-query";

import { workspaceApi } from "pages/app/workspace/services";

export const useSchoolTeamIdentity = (teamId: string, routeSchoolId?: string) => {
  const teamQuery = useQuery({
    queryKey: ["school-team-profile", teamId],
    queryFn: () => workspaceApi.schoolTeams.get(teamId),
    enabled: Boolean(teamId),
  });

  const team = teamQuery.data;
  const resolvedSchoolId = String(team?.school_id || routeSchoolId || "");

  return {
    isLoading: teamQuery.isLoading,
    resolvedSchoolId,
    team,
    teamQuery,
  };
};
